const members = {
  clement: {
    position: "Dirigeant associé",
    text: "Ingénieur en développement 3D et spécialisé dans les technologies mobiles depuis 2010, Clément a fondé CDO Apps en 2016.<br /><br />Il est le garant de la qualité des applications développées par le studio.",
  },
  lydie: {
    position: "Associée et cheffe de projet",
    text: "Ingénieure en système embarqué, Lydie est co-fondatrice de CDO Apps.<br /><br />Elle est en charge de la gestion des projets et de la relation client. Elle assure le suivi des développements et la qualité des livrables.",
  },
  romuald: {
    position: "Développeur",
    text: "Ingénieur en robotique, Romuald se spécialise dans le développement d'applications iOS et rejoint CDO Apps en 2020.<br /><br />Flutter est devenu son outil de prédilection pour le développement multiplateforme.",
  },
  vincent: {
    position: "Développeur",
    text: "Développeur dans le jeu vidéo, Vincent nous rejoint en 2019.<br /><br />Son expertise en développement Unity et en game design est un atout pour les projets de jeux mobiles et expériences interactives.",
  },
  marion: {
    position: "Directrice artistique",
    text: "Graphiste et illustratrice, Marion est notre partenaire pour la création de l'identité visuelle de vos applications.<br /><br />Elle conçoit les interfaces et les éléments graphiques de nos projets.",
  },
  uriel: {
    position: "Animateur 2D/3D",
    text: "Avec son expertise en animation, Uriel apporte du dynamisme et de la vie à vos projets.",
  },
  maxime: {
    position: "Sound designer",
    text: "Maxime est un compositeur et sound designer spécialisé dans la création d'assets audio pour les jeux vidéo.<br /><br />Nous collaborons avec lui pour enrichir les expériences sonores de nos applications.",
  },
};

export default members;
